import React from 'react';
import { T } from '@tolgee/react';
import { TrackingBuyerStep } from '../orderTracking.interface';
import { Checkmark } from '../../../../assets/Checkmark';
import { cn } from '../../../../lib/utils';

interface BuyerStepsListProps {
	steps: TrackingBuyerStep[];
	current: number;
}

const BuyerStepsList: React.FC<BuyerStepsListProps> = ({ steps, current }) => {
	const isLast = current >= steps.length;

	return (
		<div className="flex flex-col gap-2 pt-1 pb-2">
			{steps.map((step, index) => {
				const position = index + 1;
				const done = position < current || isLast;
				const active = position === current && !isLast;

				return (
					<div
						key={step.labelKey}
						className="flex items-center justify-between gap-3"
					>
						<div className="flex items-center gap-3 min-w-0">
							<span
								className={cn(
									'w-6 h-6 rounded-full grid place-items-center flex-none text-xs font-semibold box-border',
									done
										? 'bg-track-teal text-white'
										: active
										? 'bg-track-amber-soft border-2 border-solid border-track-amber text-track-amber-ink'
										: 'bg-white border-2 border-solid border-track-line text-track-muted',
								)}
							>
								{done ? (
									<Checkmark color="#FFFFFF" width={11} height={8} />
								) : (
									position
								)}
							</span>
							<span
								className={cn(
									'text-sm leading-[1.3] truncate',
									done
										? 'font-medium text-track-ink'
										: active
										? 'font-medium text-track-ink'
										: 'text-track-muted',
								)}
							>
								<T keyName={step.labelKey}>{step.defaultLabel}</T>
							</span>
						</div>
						<span
							className={cn(
								'inline-flex items-center h-[22px] px-[10px] rounded-full text-xs font-semibold whitespace-nowrap flex-none',
								done
									? 'bg-track-indigo-soft text-track-indigo'
									: active
									? 'bg-track-amber text-track-amber-ink'
									: 'bg-track-surface text-track-slate',
							)}
						>
							{done ? (
								<T keyName="expandedStepper.done">Done</T>
							) : active ? (
								<T keyName="expandedStepper.inProgress">In Progress</T>
							) : (
								<T keyName="expandedStepper.toDo">To do</T>
							)}
						</span>
					</div>
				);
			})}
		</div>
	);
};

export default BuyerStepsList;
